import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GraphicBarIncreaseSvg = function GraphicBarIncreaseSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.294 4.353-2.918-.764.368-1.34 5.26 1.377-1.41 5.138-1.372-.359.782-2.85-17.289 9.749-.71-1.202zM22.005 11.379h-7.568v3.7H8.28v3.7H2v3.47h1.42v-2.081h4.86v2.081h1.421v-5.782h4.736v5.782h1.42v-9.483h4.727v9.483h1.42z"
  }));
};
export var GraphicBarIncrease = function GraphicBarIncrease(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GraphicBarIncreaseSvg
  }));
};